/**
 * Defines the type of the day that can be displayed in the calendar.
 */
export const DayType = {
  Empty: Symbol('Empty'),
  UnavailablePrevious: Symbol('UnavailablePrevious'),
  SelectedStart: Symbol('SelectedStart'),
  SelectedEnd: Symbol('SelectedEnd'),
  Available: Symbol('Available'),
  UnavailableFuture: Symbol('UnavailableFuture'),
  NoCheckIn: Symbol('NoCheckIn'),
  NoCheckOut: Symbol('NoCheckOut'),
  GroupCodeAvailable: Symbol('GroupCodeAvailable'),
  SelectedSpinner: Symbol('SelectedSpinner')
};


// WEBPACK FOOTER //
// ./src/components/pages/theme/calendar/DayType.js